export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const extractFileId = (viewLink) => {
    try {
        if (!viewLink) return null;

        const match = viewLink.match(/\/file\/d\/([^/]+)/);
        return match ? match[1] : null;

    } catch (error) {
        console.error('Error extracting file ID:', error);
        return null;
    }
};